const STORAGE_KEY = "asn_group_download_job";

// Minimal resume state so an in-progress job survives a hard page refresh:
// just enough to keep polling and avoid re-downloading bundles already saved.
export const saveGroupDownloadState = ({ jobId, downloadedBundles }) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ jobId, downloadedBundles }));
  } catch {
    // ignore storage errors (e.g. private browsing)
  }
};

export const loadGroupDownloadState = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const clearGroupDownloadState = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
};
